module.exports = __webpack_public_path__ + "img/sw.953891eb.png";